const DB_NAME = "PlutonicChecklistDB";
const DB_VERSION = 1;
const STORE_NAME = "checklists";

export const openChecklistDB = () => {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, DB_VERSION);

    request.onupgradeneeded = () => {
      const db = request.result;

      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME);
      }
    };

    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });
};

export const saveChecklist = async (userId, checklist) => {
  const db = await openChecklistDB();

  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE_NAME, "readwrite");
    const store = tx.objectStore(STORE_NAME);

    const request = store.put(checklist, String(userId));

    request.onsuccess = () => {

    };

    request.onerror = () => {
      console.error("Put failed");
    };

    tx.oncomplete = () => resolve();
    tx.onerror = () => reject(tx.error);
    tx.onabort = () => reject(tx.error);
  });
};

export const loadChecklist = async (userId) => {
  if (!userId) return {};

  const db = await openChecklistDB();

  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE_NAME, "readonly");
    const store = tx.objectStore(STORE_NAME);

    const request = store.get(String(userId));

    request.onsuccess = () => resolve(request.result || {});
    request.onerror = () => reject(request.error);
  });
};